import BaseCollection from '../../../collections/base';
import LibraryModel from '../models/library';

const LibraryCollection = BaseCollection.extend({

    model: LibraryModel,

    url() {
        return window.url(window.routes.getBranches);
    }
});

export default LibraryCollection;
